'use client';

import { getCookie } from 'cookies-next';
import { useEffect, useRef, useState } from 'react';
import {
  useOrderNotificationSSE,
  type OrderNotification,
} from '@/api/use-order-notification';
import { OrderNotificationToast } from '@/components/order-notification-toast';
import { getAuthToken } from '@/lib/auth/get-token';

export default function NotificationDemo() {
  const [currentNotification, setCurrentNotification] =
    useState<OrderNotification | null>(null);
  const displayedIds = useRef<Set<string>>(new Set());
  const token = getAuthToken();

  const { status, error } = useOrderNotificationSSE({
    token: token,
    enabled: !!token, // Only enable when token is available
    onMessage: (msg) => {
      // Create a unique ID for the notification to prevent duplicates
      const notificationId = `${msg.order_code}-${msg.time}`;

      if (!displayedIds.current.has(notificationId)) {
        console.log('📩 New order notification:', msg);
        setCurrentNotification(msg);
        displayedIds.current.add(notificationId);
      }
    },
    onError: (err) => {
      console.error('❌ SSE Error:', err);
    },
  });

  const handleCloseNotification = () => {
    setCurrentNotification(null);
  };

  // Log connection status changes in development
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      console.log('[OrderNotification] SSE Status:', status);

      if (error) {
        console.error('[OrderNotification] SSE Error:', error);
      }
    }
  }, [status, error]);

  return (
    <>
      <OrderNotificationToast
        notification={currentNotification}
        onClose={handleCloseNotification}
      />
    </>
  );
}
